
import { apiHelper } from "../apiHelper/apiHelper";
import { formHelper } from "../apiHelper/formHelper";
import {
  getcropRequest,
  getcropSuccess,
  getcropFailure,
  getRegionsSuccess,
  getRegionsRequest,
  getRegionsFailure,
  getCropRegionsSuccess,
  getCropRegionsRequest,
  getCropRegionsFailure,
  createCropRequest,
  createCropSuccess,
  createCropFailure,
  updateRegionRequest,
  updateRegionSuccess,
  updateRegionFailure,
} from "../slices/cropSlices";

// ========================== NEW API HANDLER =================

// get Crop list
export const handleGetCropList = async (dispatch) => {
  const endPoint = "crop/crops/all";
  const method = "GET";
  const state1 = getcropRequest;
  const state2 = getcropSuccess;
  const state3 = getcropFailure;
  const isToast = false;
  const isFile = false;
  const isToken = true;
  return await apiHelper(
    endPoint,
    method,
    null,
    state1,
    state2,
    state3,
    dispatch,
    isFile,
    isToast,
    isToken
  );
};

// get Regions list
export const handleGetRegionsList = async (dispatch) => {
  const endPoint = "crop/regions/all";
  const method = "GET";
  const state1 = getRegionsRequest;
  const state2 = getRegionsSuccess;
  const state3 = getRegionsFailure;
  const isToast = false;
  const isFile = false;
  const isToken = true;
  return await apiHelper(
    endPoint,
    method,
    null,
    state1,
    state2,
    state3,
    dispatch,
    isFile,
    isToast,
    isToken
  );
};

// Get Available Regions By Crop ID (regions without schedualers for this crop)
export const handleGetAvailableRegionsByCropId = async (dispatch, cropId) => {
  const endPoint = `crop/regions/available/${cropId}`;
  const method = "GET";
  const state1 = getCropRegionsRequest;    // dispatch loading
  const state2 = getCropRegionsSuccess;    // dispatch success
  const state3 = getCropRegionsFailure;    // dispatch failure
  const isToast = false;
  const isFile = false;
  const isToken = true;

  return await apiHelper(
    endPoint,
    method,
    null,         // no body since it's a GET request
    state1,
    state2,
    state3,
    dispatch,
    isFile,
    isToast,
    isToken
  );
};


// create Regin
export const handleCreateRegion = async (formData, dispatch) => {

  const endPoint = "crop/region/create";
  const method = "POST";
  const state1 = createCropRequest;
  const state2 = createCropSuccess;
  const state3 = createCropFailure;
  const isToast = true;
  const isFile = false;
  const isToken = true;
  const body = formData;
  return await apiHelper(
    endPoint,
    method,
    body,
    state1,
    state2,
    state3,
    dispatch,
    isFile,
    isToast,
    isToken
  );
};


export const handleEditRegion = async (regionId, formData, dispatch) => {
  const endPoint = `crop/region/${regionId}`;
  const method = "PUT";
  const state1 = updateRegionRequest;   // You can create specific states like updateRegionRequest if needed
  const state2 = updateRegionSuccess;
  const state3 = updateRegionFailure;
  const isToast = true;
  const isFile = false;
  const isToken = true;
  const body = formData;

  return await apiHelper(
    endPoint,
    method,
    body,
    state1,
    state2,
    state3,
    dispatch,
    isFile,
    isToast,
    isToken
  );
};


export const handleDeleteRegion = async (regionId, dispatch) => {
  const endPoint = `crop/region/${regionId}`;
  const method = "DELETE";
  const state1 = getRegionsRequest;
  const state2 = getRegionsSuccess;
  const state3 = getRegionsFailure;
  const isToast = true;
  const isFile = false;
  const isToken = true;

  return await apiHelper(
    endPoint,
    method,
    null,         // No body needed for DELETE
    state1,
    state2,
    state3,
    dispatch,
    isFile,
    isToast,
    isToken
  );
};


// Create Crop
export const handleCreateCrop = async (formData, dispatch) => {

  const endPoint = "crop/create";
  const method = "POST";
  const state1 = createCropRequest;
  const state2 = createCropSuccess;
  const state3 = createCropFailure;
  const isToast = true;
  const isFile = true;
  const isToken = true;
  const body = formData;
  return await formHelper(
    endPoint,
    method,
    body,
    state1,
    state2,
    state3,
    dispatch,
    isFile,
    isToast,
    isToken
  );
};

export const handleUpdateCrop = async (cropId, formData, dispatch) => {
  const endPoint = `crop/${cropId}`;
  const method = "PUT";
  const state1 = updateRegionRequest; // You can rename or add a new set of updateCropRequest states
  const state2 = updateRegionSuccess;
  const state3 = updateRegionFailure;
  const isToast = true;
  const isFile = false;
  const isToken = true;
  const body = formData;

  return await formHelper(
    endPoint,
    method,
    body,
    state1,
    state2,
    state3,
    dispatch,
    isFile,
    isToast,
    isToken
  );
};


export const handleDeleteCrop = async (cropId, dispatch) => {
  const endPoint = `crop/${cropId}`;
  const method = "DELETE";
  const state1 = getcropRequest;
  const state2 = getcropSuccess;
  const state3 = getcropFailure;
  const isToast = true;
  const isFile = false;
  const isToken = true;

  return await apiHelper(
    endPoint,
    method,
    null, // No body required for DELETE
    state1,
    state2,
    state3,
    dispatch,
    isFile,
    isToast,
    isToken
  );
};
